import {
    ContextMenuItem,
    DropdownV2,
    Icon,
    PriorityIcon
} from '@priority-software/priority-style-react';
import React, {useEffect, useRef, useState} from 'react';
import {isUpword} from '../utils/submenu';
import {maxSubmenuHeight, menuItemHeight} from '../consts';
import {isRTL} from '../../../Localization';
import cx from 'classnames';
import styles from '../styles/menu.module.scss';
import {helpPopoverRef} from '../../../_shared/Help/constants';

export const Menu = ({menuData, menuStyle, setIsMenuOpen, menuActionHandler, pack}) => {
    return (
        <DropdownV2 isOpen={true} openingSide="leftSide" width={'contentWidth'} onClose={() => {}}>
            {renderMenu(menuData, setIsMenuOpen, false, menuStyle, menuActionHandler, pack)}
        </DropdownV2>
    );
};

const renderMenu = (
    data,
    setIsMenuOpen,
    isSubmenu,
    menuStyle = null,
    menuActionHandler = null,
    pack
) => {
    return (
        <div
            className={
                isSubmenu ? (data.length > maxSubmenuHeight ? styles.submenu : null) : styles.menu
            }
            style={menuStyle}
        >
            {data?.map(option => {
                return (
                    <MenuItem
                        key={option.title}
                        option={option}
                        setIsMenuOpen={setIsMenuOpen}
                        menuActionHandler={menuActionHandler}
                        pack={pack}
                    />
                );
            })}
        </div>
    );
};

const MenuItem = ({option, setIsMenuOpen, menuActionHandler, pack}) => {
    const [menuPosition, setMenuPosition] = useState(null);
    const arrowRef = useRef(null);
    const helpRef = useRef(null);
    const {current: ref} = helpPopoverRef;
    useEffect(() => {
        if (option.subMenu && option.subMenu.length) {
            const visibleItemsCount =
                option.subMenu.length > maxSubmenuHeight ? maxSubmenuHeight : option.subMenu.length;
            if (isUpword(arrowRef, visibleItemsCount)) {
                setMenuPosition(
                    '-' + (visibleItemsCount * menuItemHeight - menuItemHeight).toString() + 'px'
                );
            } else {
                setMenuPosition('0');
            }
        }
        return () => {
            ref.handleClose();
        };
    }, []);

    const onClick = () => {
        if (option.onClick) {
            setIsMenuOpen(false);
            option.onClick();
        }
        if (option.action) {
            setIsMenuOpen(false);
            menuActionHandler(option.action);
        }
    };

    const onIconClick = e => {
        e.stopPropagation();
        const {current: help} = helpRef;

        const title = pack?.Name;
        const content = pack?.Description;

        ref.showHelpPopover({
            title,
            content,
            anchor: help,
            withFooter: false
        });
    };

    return (
        <ContextMenuItem
            key={option.title}
            onClick={onClick}
            isRTL={isRTL()}
            dropdownStyle={{top: menuPosition}}
            componentClasses={cx(styles.menuItem, {[styles.withSubmenuItem]: option.subMenu})}
            subMenu={
                option.subMenu &&
                renderMenu(
                    option.subMenu,
                    setIsMenuOpen,
                    true,
                    option.subMenu.length > maxSubmenuHeight
                        ? {maxHeight: `${maxSubmenuHeight * menuItemHeight}px`}
                        : null,
                    menuActionHandler,
                    pack
                )
            }
        >
            {option.subMenu && (
                <div ref={arrowRef}>
                    <Icon icon={PriorityIcon.arrowBottom} componentClasses={styles.menuMore} />
                </div>
            )}
            {option.title}
            {option.icon && (
                <div ref={helpRef}>
                    <Icon
                        icon={option.icon}
                        componentClasses={styles.question}
                        onClick={onIconClick}
                    />
                </div>
            )}
        </ContextMenuItem>
    );
};
